export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-record-dae0703edfe7536e79d4a12d4fe5e115.svg";